if (typeof BigInt === 'function') exports.default = BigInt;
else
  exports.default = function BigIntNotSupported() {
    throw new Error('BigInt is not supported in this environment.');
  };
